// constants/user.js
import * as Yup from "yup";

export const userInitialValues = {
  user: {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    password_confirmation: "",
    location: "",
    status: "active",
    user_states_attributes: [],
    user_counties_attributes: [],
  },
  user_type: "",
};

export const userSchema = Yup.object().shape({
  user: Yup.object().shape({
    first_name: Yup.string().required("First name is required"),
    last_name: Yup.string().required("Last name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string(),
    password_confirmation: Yup.string(),
    location: Yup.string(),
    status: Yup.string()
      .oneOf(["active", "inactive"])
      .required(),
    admin: Yup.boolean(),
    user_states_attributes: Yup.array(),
    user_counties_attributes: Yup.array(),
  }),
  user_type: Yup.string().required("User type is required"),
});
